/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Аутентификация
 * Аутентификация
 * OpenAPI spec version: 1.0.0
 */
import { instance } from '../instance';
import type {
  CurrentUser200,
  InvalidCredentialsError,
  SignIn200,
  SignInBody,
  UnauthenticatedError,
} from '../schemas';

/**
 * Выполнить аутентификацию пользователя и создать сессию
 * @summary Создать сессию
 */
export type signInResponse200 = {
  data: SignIn200;
  status: 200;
};

export type signInResponse401 = {
  data: InvalidCredentialsError;
  status: 401;
};

export type signInResponseSuccess = signInResponse200 & {
  headers: Headers;
};
export type signInResponseError = signInResponse401 & {
  headers: Headers;
};

export const getSignInUrl = () => {
  return `/api/v1/auth/signin`;
};

export const signIn = async (
  signInBody: SignInBody,
  options?: RequestInit,
): Promise<signInResponseSuccess> => {
  const formData = new FormData();
  formData.append(`username`, signInBody.username);
  formData.append(`password`, signInBody.password);

  return instance<signInResponseSuccess>(getSignInUrl(), {
    ...options,
    method: 'POST',
    body: formData,
  });
};

/**
 * Получить информацию о текущем пользователе
 * @summary Текущий пользователь
 */
export type currentUserResponse200 = {
  data: CurrentUser200;
  status: 200;
};

export type currentUserResponse401 = {
  data: UnauthenticatedError;
  status: 401;
};

export type currentUserResponseSuccess = currentUserResponse200 & {
  headers: Headers;
};
export type currentUserResponseError = currentUserResponse401 & {
  headers: Headers;
};

export const getCurrentUserUrl = () => {
  return `/api/v1/user`;
};

export const currentUser = async (
  options?: RequestInit,
): Promise<currentUserResponseSuccess> => {
  return instance<currentUserResponseSuccess>(getCurrentUserUrl(), {
    ...options,
    method: 'GET',
  });
};

/**
 * Завершить текущую сессию
 * @summary Завершить сессию
 */
export type signoutResponse200 = {
  data: void;
  status: 200;
};

export type signoutResponseSuccess = signoutResponse200 & {
  headers: Headers;
};
export const getSignoutUrl = () => {
  return `/api/v1/auth/signout`;
};

export const signout = async (
  options?: RequestInit,
): Promise<signoutResponseSuccess> => {
  return instance<signoutResponseSuccess>(getSignoutUrl(), {
    ...options,
    method: 'POST',
  });
};
